module.exports = __webpack_public_path__ + "img/bannerM.f70df767.png";